// Used a separate file for bundling
export function isTextAlignmentPanelSupported(
	zone: eXpress.core.IZone | undefined,
	definition: eXpress.core.IDefinition | null | undefined,
	dashboard: eXpress.TextZoneDashboard,
) {
	if (zone) {
		return dashboard.canSetHorizontalAlignment(zone) || dashboard.canSetVerticalAlignment(zone);
	}
	if (!definition) return false;
	return definition
		.textZones()
		.some(
			(textZone) =>
				dashboard.canSetHorizontalAlignment(textZone) ||
				dashboard.canSetVerticalAlignment(textZone),
		);
}
